import styles from "./Join_Missed.module.scss";

import { useCallback } from "react";

import { useNavigate } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";
import { PageContainer } from "@/modules/shared/components/PageContainer";

type Join_MissedProps = {
  rescheduleUuid: string | null;
};

export function Join_Missed({ rescheduleUuid }: Join_MissedProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOnRescheduleClick = useCallback(() => {
    navigate({
      to: `/$sessionCode/reschedule/${rescheduleUuid}`,
    });
  }, [navigate, rescheduleUuid]);

  return (
    <PageContainer variant="constrained">
      <div className={styles.container}>
        <span className={styles.title}>
          {t("coachingSession.missed.title")}
        </span>

        <Trans
          i18nKey="coachingSession.missed.description"
          components={{
            first: <p className={styles.description} />,
            second: <p className={styles.description} />,
            third: <p className={styles.description} />,
          }}
        />

        <AppButton variant="critical" onClick={handleOnRescheduleClick}>
          <span>{t("coachingSession.missed.cta")}</span>
        </AppButton>
      </div>
    </PageContainer>
  );
}
